// apps/client/src/assets/manifest.ts — the built asset manifest (tools/assets writes it; §8.8)
import type { BuiltManifest } from '@whiskerton/content';
import { BUILD_ID } from '../boot/env';
export class MissingManifestError extends Error { constructor() { super('apps/client/public/assets/manifest.json is missing: run `pnpm assets`'); } }
export async function loadManifest(): Promise<BuiltManifest> {
  const res = await fetch(`/assets/manifest.json?b=${encodeURIComponent(BUILD_ID)}`);
  if (!res.ok || !(res.headers.get('content-type') ?? '').includes('json')) throw new MissingManifestError();
  return (await res.json()) as BuiltManifest;
}
